import React from 'react';

/**
 * Usage instructions component for the dashboard
 */
export const UsageInstructions: React.FC = () => {
  return (
    <div className="bg-gray-50 border border-gray-200 rounded-lg p-6">
      <div className="flex items-start gap-4">
        <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0">
          <span className="text-gray-600 font-semibold text-sm">ℹ️</span>
        </div>
        <div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            كيفية استخدام النظام
          </h3>
          <ul className="text-gray-700 space-y-1">
            <li>• استخدم القائمة الجانبية للتنقل بين الوحدات المختلفة</li>
            <li>• كل وحدة متاحة بناءً على صلاحياتك</li>
            <li>• يمكنك الوصول إلى المزيد من الخيارات من كل وحدة</li>
          </ul>
        </div>
      </div>
    </div>
  );
};
